import { render, staticRenderFns } from "./CardPictos.vue?vue&type=template&id=8b0503dc&scoped=true&"
import script from "./CardPictos.vue?vue&type=script&lang=js&"
export * from "./CardPictos.vue?vue&type=script&lang=js&"
import style0 from "./CardPictos.vue?vue&type=style&index=0&id=8b0503dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0503dc",
  null
  
)

export default component.exports